import { render, staticRenderFns } from "./Weight.vue?vue&type=template&id=6aadef0f&scoped=true"
import script from "./Weight.vue?vue&type=script&lang=js"
export * from "./Weight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aadef0f",
  null
  
)

export default component.exports